var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6104 12.275C24.9037 11.9817 24.9037 11.5062 24.6104 11.2129C24.3171 10.9196 23.8415 10.9196 23.5483 11.2129L19.0834 15.6778L15.8729 11.2998C15.7315 11.1069 15.5065 10.9929 15.2673 10.9929H12.0626C11.7796 10.9929 11.5206 11.152 11.3926 11.4045C11.2647 11.6569 11.2896 11.9599 11.4569 12.1881L16.1598 18.6013L11.5315 23.2297C11.2382 23.5229 11.2382 23.9985 11.5315 24.2918C11.8248 24.5851 12.3003 24.5851 12.5936 24.2918L17.0585 19.8269L20.269 24.2049C20.4105 24.3978 20.6354 24.5118 20.8746 24.5118H24.0793C24.3623 24.5118 24.6214 24.3527 24.7493 24.1002C24.8772 23.8478 24.8524 23.5448 24.685 23.3166L19.9821 16.9034L24.6104 12.275ZM18.3491 17.2165C18.3723 17.2552 18.3992 17.2921 18.43 17.327L22.5972 23.0097H21.2552L13.5447 12.495H14.8867L18.3491 17.2165Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0749,
    cy: 18.0251,
    r: 17.6496,
    stroke: "#5D5D5D",
    strokeWidth: 0.751047
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.77dbc24ceaec8955bf726640a281094a.svg";
export { ForwardRef as ReactComponent };